<template>
  <li :class="$style.tab" :data-qa="`${name}-tab`" role="presentation">
    <a
      v-bind="attributes"
      :id="`tab-${name}`"
      ref="tab"
      role="tab"
      :class="$style.content"
      @click="handleSelect"
      @keydown.left="selectPrev"
      @keydown.right="selectNext"
    >
      <slot :select="handleSelect" />
    </a>
  </li>
</template>

<script>
import { select, isActive, selectPrev, selectNext, addTab, removeTab } from './symbols';

export default {
  name: 'BaseTab',
  inject: {
    select,
    isActive,
    selectPrev,
    selectNext,
    addTab,
    removeTab
  },
  inheritAttrs: false,
  props: {
    name: {
      type: [String, Number],
      required: true
    },
    href: {
      type: String,
      required: true
    }
  },
  emits: ['selected'],
  computed: {
    selected() {
      return this.isActive(this.name);
    },
    attributes() {
      const attributes = {
        href: this.href
      };
      if (this.selected) {
        attributes['aria-selected'] = 'true';
      } else {
        attributes.tabindex = -1;
      }
      return attributes;
    }
  },
  watch: {
    selected(flag) {
      if (flag) {
        this.$refs.tab.focus();
      }
    }
  },
  mounted() {
    this.addTab(this.name);
  },
  beforeDestroy() {
    this.removeTab(this.name);
  },
  methods: {
    handleSelect(e) {
      this.$emit('selected', e);
      e.preventDefault();
      this.select(this.name);
    }
  }
};
</script>

<style module lang="less">
@import '~@less/common/variables';

.tab {
  display: inline-block;
}
.content {
  display: inline-block;
  padding: 0 15px;
  height: 30px;
  position: relative;
  vertical-align: bottom;
  cursor: default;
  text-decoration: none;
  background-color: white;
  font-weight: bold;
  font-size: 11px;
  line-height: 32px;
  color: @lightTextColor;
  white-space: nowrap;
  text-transform: uppercase;
}
.content[aria-selected] {
  border: 1px solid #ccc;
  color: @textColor;
  height: 32px;
  margin-bottom: -1px;
  border-bottom: 1px solid white;
  border-radius: 3px 3px 0 0;
}
</style>

<i18n lang="json" />
